<div class="footer3 legal">
  <app-footer2></app-footer2>
  <div class="content">
    <div>Copyright &copy; 1992-{{year}} DPC DATA Inc.</div>
    <div>All rights reserved.</div>
  </div>
</div>
